import { render, staticRenderFns } from "./ChangeOfDirectionPage.vue?vue&type=template&id=6948dfcc&"
import script from "./ChangeOfDirectionPage.vue?vue&type=script&lang=js&"
export * from "./ChangeOfDirectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports